/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Link_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not link that reference. Please try again." |
*
* @param {Chat_Mentions_Link_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_error = /** @type {((inputs?: Chat_Mentions_Link_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Referenz konnte nicht verknüpft werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Could not link that reference. Please try again.")
});